<template>
  <v-container>
    <sub-navigation></sub-navigation>

    <v-dialog
      v-model="dialogDetail"
      max-width="1200px"
      transition="dialog-transition"
      v-if="dialogDetail"
    >
    <v-card flat class="no__padding">
      <v-card-title v-if="!loadingDetail" class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
        <h2>Objednávka č. {{detailItem.cislo_nakupu}}</h2>
      </v-card-title>
      <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
        <div v-if="loadingDetail" class="pa-5">
          <Loader :loading="true" skin="light"></Loader>
        </div>
        <div v-else>
          <v-card class="grey lighten-4" :class="{'pl-0 pr-O': $vuetify.breakpoint.smAndDown}">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  Datum: <strong>{{detailItem.datum | formatDate}}</strong>
                </v-flex>
                <v-flex xs12 sm6>
                  Variabilní symbol: <strong>{{detailItem.variabilni_symbol}}</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-4">
                <v-flex xs12 sm6>
                  Stav: <strong>{{detailItem.stav_objednavky.nazev}}</strong>
                </v-flex>
                <v-flex xs12 sm6>
                  Doručení: <strong v-if="detailItem.zpusob_doruceni!=null">{{detailItem.zpusob_doruceni.nazev}}</strong><strong v-else>--</strong>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card class="grey lighten-4 mt-3" :class="{'pl-0 pr-O': $vuetify.breakpoint.smAndDown}">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <h3>Fakturační adresa:</h3>
                  <adresa-view :adresa="detailItem.fa_adresa" class="mt-2"></adresa-view>
                </v-flex>
                <v-flex xs12 sm6>
                  <h3>Doručovací adresa:</h3>
                  <adresa-view :adresa="detailItem.dod_adresa" class="mt-2"></adresa-view>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card color="grey lighten-4 mt-3" :class="{'pl-3 pr-3': $vuetify.breakpoint.smAndDown}">
            <h4 class="mx-0">Produkty v objednávce:</h4>
            <v-data-table
              :headers="detailProductsHeaders"
              :items="detailItem.polozky"
              :pagination.sync="pagination"
              :total-items="pagination.totalItems"
              :rows-per-page-items="[25, 50, 100, 200]"
              class="mt-2"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>
                    <eshop-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">{{props.item.produkt.nazev}}</eshop-link>
                  </td>
                  <td class="text-xs-right">
                    {{props.item.castka_mj | formatMoney}} {{props.item.mena.zkratka}}
                  </td>
                  <td class="text-xs-right">
                    <span v-if="props.item.sleva>0">{{props.item.sleva | formatMoney}} {{props.item.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                  <td class="text-xs-right">
                    <span v-if="props.item.castka_dph_10>0">{{props.item.castka_dph_10 | formatMoney}} {{props.item.mena.zkratka}}</span>
                    <span v-else-if="props.item.castka_dph_15>0">{{props.item.castka_dph_15 | formatMoney}} {{props.item.mena.zkratka}}</span>
                    <span v-else-if="props.item.castka_dph_21>0">{{props.item.castka_dph_21 | formatMoney}} {{props.item.mena.zkratka}}</span>
                    <span v-else>0 {{props.item.mena.zkratka}}</span>
                  </td>
                  <td class="text-xs-right">
                    {{props.item.kredity | formatDouble}} kr.
                  </td>
                  <td class="text-xs-right">
                    {{props.item.mnozstvi}} ks
                  </td>
                  <td class="text-xs-right">
                    <span v-html="computePrice(props.item.castka_mj - props.item.sleva, props.item.mnozstvi)"></span>&nbsp;{{props.item.mena.zkratka}}
                  </td>
                </tr>
              </template>
              <template slot="footer">
                <tr>
                  <td>Celkem bez DPH:</td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError">{{detailItem.castka_celkem_bez_dph | formatMoney}} {{detailItem.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr v-if="detailItem.castka_celkem_dph_10>0">
                  <td>DPH 10%</td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError">{{detailItem.castka_celkem_dph_10 | formatMoney}} {{detailItem.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr v-if="detailItem.castka_celkem_dph_15>0">
                  <td>DPH 15%</td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError">{{detailItem.castka_celkem_dph_15 | formatMoney}} {{detailItem.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr v-if="detailItem.castka_celkem_dph_21>0">
                  <td>DPH 21%</td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError">{{detailItem.castka_celkem_dph_21 | formatMoney}} {{detailItem.mena.zkratka}}</span>
                    <span v-else>--</span>
                  </td>
                </tr>
                <tr>
                  <td><strong>Celkem s DPH:</strong></td>
                  <td colspan="7" class="text-xs-right">
                    <span v-if="!computingError"><strong>{{detailItem.castka_celkem | formatMoney}} {{detailItem.mena.zkratka}}</strong></span>
                    <span v-else>--</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-card-text>
      <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
        <v-spacer></v-spacer>
        <v-btn color="grey" flat @click="dialogDetail=false">Zavřít</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>

    <v-layout row wrap>
      <v-flex xs12>
        <!-- <h1 class="h2 mb-30">Moje zboží</h1> -->
        <v-layout row wrap class="shop-layout mb-20 mt-3">
          <v-flex xs12 class="ml-2 px-2" :class="{'mb-2 ml-4': $vuetify.breakpoint.smAndUp}">
            <v-layout row wrap align-center>
              <v-flex shrink class="pr-2">
                <strong>Filtr <v-icon color="orange" class="filter-img">sort</v-icon></strong>
              </v-flex>
              <v-flex sm4 class="pl-1" :class="{'px-3': $vuetify.breakpoint.smAndUp}">
                <v-text-field
                  label="Hledáte něco konkrétního?"
                  autocomplete
                  solo
                  hide-details
                  append-icon="search"
                  v-model="search"
                ></v-text-field>
              </v-flex>
              <v-flex sm4 class="pl-0" :class="{'pl-3 mt-0': $vuetify.breakpoint.smAndUp}">
                <v-select
                  label="Stav"
                  solo
                  hide-details
                  :items="stavy"
                  v-model="filtr_predani"
                  item-value="id"
                  item-text="text"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-0"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
          :loading="loadingTable"
          :search="search"
        >
          <template v-slot:items="props">
            <td>{{ props.item.datum | formatSimpleDate }}</td>
            <td><eshop-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank" class="link-black">{{ props.item.produkt.nazev }}</eshop-link></td>
            <td class="text-xs-right">{{ props.item.mnozstvi }} ks</td>
            <td>
              <span v-if="props.item.typ=='jednorazovy_nakup'">Jednorázový nákup č. {{props.item.polozka.variabilni_symbol}}</span>
              <span v-else-if="props.item.typ=='sporeni'">Postupný nákup {{props.item.polozka.nazev_sporeni}}</span>
            </td>
            <td>
              <span v-if="props.item.predano">Předáno</span>
              <span v-else-if="props.item.informovan">Zaplaceno</span>
            </td>
            <!-- <td class="text-xs-center">
              <v-btn color="orange" dark class="elevation-0 ma-0 bold"><v-icon class="mr-3">save_alt</v-icon> Faktura</v-btn>
            </td> -->
            <td class="text-xs-right">
              <button-link color="orange" dark class="elevation-0 ma-0 bold" :to="'/jednorazove-nakupy/'+props.item.polozka.id" v-if="props.item.typ=='jednorazovy_nakup'"><v-icon class="ma-0">remove_red_eyes</v-icon> Detail</button-link>
              <button-link color="orange" dark class="elevation-0 ma-0 bold" :to="'/postupne-nakupy'" v-else><v-icon class="ma-0">remove_red_eyes</v-icon> Detail</button-link>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        loadingTable: true,
        search: "",
        dialogDetail: false,
        headers: [
          { text: 'Datum', value: 'datum', sortable: false },
          { text: 'Produkt', value: 'produkt', sortable: false },
          { text: 'Množství', value: 'mnozstvi', sortable: false, align: 'right' },
          { text: 'Způsob pořízení', value: 'zpusob_porizeni', sortable: false },
          { text: 'Stav', value: 'stav', sortable: false },
          // { text: 'Faktura', value: null, sortable: false, align: "center" },
          { text: 'Detail nákupu', value: null, sortable: false, align: "right" }
        ],
        items: [],
        timeout: null,
        counter: 0,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 25,
          sortBy: "datum",
          totalItems: 0,
          pages: 0
        },
        filtr_predani: 0,
        stavy: [
          {
            id: 0,
            text: "Vše"
          },
          {
            id: 1,
            text: "K předání"
          },
          {
            id: 2,
            text: "Předáno"
          }
        ]
      }
    },
    watch: {
      pagination: {
    		handler: function(newValue) {
          if (!this.loadingTable)
    			   this.load();
    		},
    		deep: true
    	},
      filtr_predani () {
        this.load();
      },
      search () {
        this.queryList();
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      queryList: function() {
        if (this.timeout != null)
          clearTimeout(this.timeout);
        this.timeout = setTimeout(function() {
          this.pagination.page = 1;
          this.load();
        }.bind(this), 200)
      },
      load (f) {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("moje-zbozi/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter,
          stav: this.filtr_predani
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.pagination.descending = body.sort.descending;
          this.pagination.page = body.sort.page;
          this.pagination.rowsPerPage = body.sort.rowsPerPage;
          this.pagination.totalItems = body.sort.totalItems;
          this.pagination.pages = body.sort.pages;
          this.loading = false;
          this.loadingTable = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    }
  }
</script>
